var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBifsoColor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        font-family: HelveticaNeueLTPro-Roman, 'Helvetica Neue LT Pro';\n        font-size: 26.7px;\n        letter-spacing: 0em;\n      }\n\n      .cls-1, .cls-2 {\n        fill: #232323;\n      }\n\n      .cls-3 {\n        fill: #d9d9d6;\n      }\n\n      .cls-4 {\n        fill: #eaaa00;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Backgrounds"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "For_Color_Icons",
    "data-name": "For Color Icons",
    className: "cls-3",
    width: 200,
    height: 200
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "BIFSO"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 40.3,
    y: 41.21,
    width: 118.31,
    height: 118.31,
    rx: 9.21,
    ry: 9.21,
    transform: "translate(100.1 -40.93) rotate(45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m163.02,93.07l-56.26-56.26c-4.03-4.03-10.56-4.03-14.59,0l-56.26,56.26c-4.03,4.03-4.03,10.56,0,14.59l56.26,56.26c4.03,4.03,10.56,4.03,14.59,0l56.26-56.26c4.03-4.03,4.03-10.56,0-14.59Zm-4.28,12.21l-54.37,54.37c-2.71,2.71-7.11,2.71-9.82,0l-54.37-54.37c-2.71-2.71-2.71-7.11,0-9.82l54.37-54.37c2.71-2.71,7.11-2.71,9.82,0l54.37,54.37c2.71,2.71,2.71,7.11,0,9.82Z"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(62.59 108.95)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "BIFSO")))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBifsoColor);
export default __webpack_public_path__ + "static/media/Bifso_Color.bc733c0d692835b715e8c211bb085618.svg";
export { ForwardRef as ReactComponent };